import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import FYHMenu from '../../components/menus/FYH';
import PhotoList from '../../components/PhotoList';
import { colors } from '../../styles';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';


const styles = css`
  .PageSection_wrapper {
    max-width: 100%;
    padding: 20px 0;
    @media (min-width: 768px) {
      padding: 50px 0;
    }
  }
  .BuilderWrapper {
    border-bottom: solid 1px ${colors.color4};
    padding: 30px 0;
    margin-bottom: 50px;
    @media (min-width: 992px) {
      margin: 0;
    }
  }
  .BuilderName {
    font-size: 30px;
    margin-bottom: 15px;
    padding-top: 15px;
    &::after {
      content: '';
      display: block;
      width: 75px;
      margin: 15px 0;
      height: 3px;
      background-color: ${colors.color2};
    }
  }
  .ContentWrapper {
    display: flex;
    flex-direction: column;
    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
  .DescriptionWrapper {
    width: 100%;
    @media (min-width: 992px) {
      margin:0 30px 0 0;
      width: 60%;
    }
  }
  .BuilderLogo {
    width: 100%;
    background-color: #FFFFFF;
    padding: 15px;
    margin:0;
    @media (min-width: 992px) {
      margin:0 30px 0 0;
      width: 40%;
    }
    img {
      width: 100%;
    }
  }
  .BuilderGallery {
    padding-top: 15px;
  }
`;


function ApprovedBuilders({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <FYHMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <div className="PageSection_wrapper ApprovedBuilders_wrapper">
        <div className="container">
          {
          get(page, 'approved_builders') && get(page, 'approved_builders').length > 0 &&
           get(page, 'approved_builders').map(item => (
             <div key={item._id} className="SectionContentBanner BuilderWrapper">
               <div className="ContentWrapper">
                 <div className="BuilderLogo">
                   <img src={get(item, 'logo.contentUrl')} alt="" />
                 </div>
                 <div className="descriptionWrapper">
                   <h3 className="PageSection_title BuilderName">{item.name}</h3>
                   <span className="PageSection_copy" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'description'))} />
                   <div className="BuilderGallery">
                     <LightBoxPhotoList
                       photos={item.gallery}
                       show={6}
                     />
                   </div>
                 </div>
               </div>
             </div>
           ))
          }
          {
            get(page, 'photo_gallery', []).length > 0 &&
              <PhotoList photos={get(page, 'photo_gallery', [])} />
          }
        </div>
      </div>
    </PageWrapper>
  );
}

ApprovedBuilders.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'approved_builders',
})(ApprovedBuilders);



// WEBPACK FOOTER //
// ./src/pages/ApprovedBuilders/index.js